import React from "react";

interface HeaderProps {
  title: string;
  icon: string;
}

const Header: React.FC<HeaderProps> = ({ title, icon }) => (
  <header id="header" className="">
    <div className="mx-auto py-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <i className={`${icon} text-2xl text-neutral-700`}></i>
          <h1 className="text-3xl font-light text-neutral-900">{title}</h1>
        </div>
      </div>
    </div>
  </header>
);

interface AdminPageLayoutProps {
  title: string;
  children: React.ReactNode;
}

export const AdminPageLayout: React.FC<AdminPageLayoutProps> = ({
  title,
  children,
}) => {
  return (
    <div className="min-h-screen">
      <Header title={title} icon="fa-solid fa-language" />
      {children}
    </div>
  );
};
